<template>
  <div class="input-wrapper">
    <textarea
      :id="fieldId"
      v-model="value"
      :autocomplete="autocomplete"
      :class="{
        'textarea-base--error': error,
        'textarea-base--disabled': disabled,
      }"
      :disabled="disabled"
      :placeholder="placeholder"
      class="textarea-base"
    />
  </div>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    autocomplete?: string;
    disabled?: boolean;
    error?: boolean;
    fieldId: string;
    placeholder?: string;
  }>(),
  {
    autocomplete: undefined,
    disabled: false,
    error: false,
    placeholder: "",
  },
);

const value = defineModel<string | null | undefined>();
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixins";

.input-wrapper {
  @apply w-full;
}

.textarea-base {
  @include inputBase;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    @apply appearance-none m-0;
  }
}
</style>
